import React from "react";
import type { IconProps } from "./types";

/**
 * A document icon component that displays a page with a folded corner,
 * representing files, documents, or file management functionality.
 * @param props - The component props
 * @param props.className - Optional CSS class name to apply to the SVG element
 * @param props.width - The width of the icon in pixels
 * @param props.height - The height of the icon in pixels
 * @returns A React functional component that renders a document SVG icon
 */
const DocIcon: React.FC<IconProps> = ({ className, width = 16, height = 16 }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 16 16"
      fill="none"
      className={className}
    >
      <path
        d="M13.4291 15.3455C13.5985 15.3455 13.761 15.2783 13.8808 15.1585C14.0006 15.0387 14.0679 14.8762 14.0679 14.7068V4.46955C14.0676 3.45756 13.6653 2.48714 12.9496 1.77168C12.2339 1.05622 11.2633 0.654297 10.2514 0.654297H2.57039C2.40098 0.654297 2.23852 0.721594 2.11873 0.841382C1.99894 0.961171 1.93164 1.12364 1.93164 1.29305V14.7068C1.93164 14.8762 1.99894 15.0387 2.11873 15.1585C2.23852 15.2783 2.40098 15.3455 2.57039 15.3455H13.4291Z"
        stroke="currentColor"
        strokeWidth="1"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.8745 0.705078V3.20962C10.8745 3.37902 10.9418 3.54149 11.0616 3.66128C11.1814 3.78107 11.3439 3.84837 11.5133 3.84837H14.0172"
        stroke="currentColor"
        strokeWidth="1"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.84814 8.31934C4.35637 8.31934 4.84377 8.52123 5.20314 8.88059C5.5625 9.23996 5.76439 9.72737 5.76439 10.2356C5.76439 10.7438 5.5625 11.2312 5.20314 11.5906C4.84377 11.9499 4.35637 12.1518 3.84814 12.1518V8.31934Z"
        stroke="currentColor"
        strokeWidth="1"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.95824 11.1937C8.95824 11.4478 8.8573 11.6915 8.67761 11.8712C8.49793 12.0509 8.25423 12.1518 8.00012 12.1518C7.74601 12.1518 7.5023 12.0509 7.32262 11.8712C7.14294 11.6915 7.04199 11.4478 7.04199 11.1937V9.27746C7.04199 9.02335 7.14294 8.77965 7.32262 8.59996C7.5023 8.42028 7.74601 8.31934 8.00012 8.31934C8.25423 8.31934 8.49793 8.42028 8.67761 8.59996C8.8573 8.77965 8.95824 9.02335 8.95824 9.27746V11.1937Z"
        stroke="currentColor"
        strokeWidth="1"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.1521 12.1518C11.6439 12.1518 11.1565 11.9499 10.7971 11.5906C10.4377 11.2312 10.2358 10.7438 10.2358 10.2356C10.2358 9.72737 10.4377 9.23996 10.7971 8.88059C11.1565 8.52123 11.6439 8.31934 12.1521 8.31934"
        stroke="currentColor"
        strokeWidth="1"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default DocIcon;
